import { BreadcrumbItem } from '@/components/Breadcrumb/Breadcrumb';
import { getCanonicalOrigin } from '@/utils/jobListingHelper';
import { resolveUrl } from '@/utils/jsonLd';

/**
 * Builds a schema.org BreadcrumbList object mirroring the visible <Breadcrumb> nav, per
 * A2P-4343. Every crumb becomes a ListItem at its rendered position; the "item" URL is
 * omitted for crumbs with no href (the current page), same as the visible nav.
 */
export const buildBreadcrumbJsonLd = (
  items: BreadcrumbItem[],
  origin: string = getCanonicalOrigin(),
) => ({
  '@context': 'https://schema.org/',
  '@type': 'BreadcrumbList',
  itemListElement: items.map((item, index) => ({
    '@type': 'ListItem',
    position: index + 1,
    name: item.label,
    ...(item.href ? { item: resolveUrl(origin, item.href) } : {}),
  })),
});
